import dayjs from 'dayjs';
import { AccountManagementRes } from '../columns';

const now = dayjs();
const enrollDate = now.subtract(1, 'month').format('MM\\DD\\YYYY');

const accountManagementData: AccountManagementRes[] = [
  {
    id: 'dd8080501',
    accountNumber: '8080501',
    accountType: 'DD',
    accountName: 'Jane Doe',
    status: 'active',
    subRows: [
      {
        id: '1',
        cif: 'ABC12|CDE34',
        name: 'Amy Denver',
        email: 'amy.de@infoimageinc.com',
        status: 'active',
        ssoEnrollDate: enrollDate,
        dsoEnrollDate: '',
        lastLogin: '',
        failedLoginCounter: '0',
        enrollmentStatus: 'Enrolled',
        checkingStatement: 'Electronic',
        loan: 'Paper',
        eTax: 'Electronic',
        notices: 'Paper',
        visa: 'Both',
        mortgage: 'Electronic',
        notification: 'Email',
        phone: '1123458923',
      },
    ],
  },
  {
    id: 'na8080502',
    accountNumber: '8080502',
    accountType: 'NA',
    accountName: 'Chris Patt',
    status: 'active',
    subRows: [
      {
        id: '2',
        cif: 'ABC12|CDE34',
        name: 'Amy Denver',
        email: 'amy.de@infoimageinc.com',
        status: 'active',
        ssoEnrollDate: enrollDate,
        dsoEnrollDate: '',
        notices: 'Paper',
        lastLogin: '',
        eTax: 'Paper',
        failedLoginCounter: '0',
        enrollmentStatus: 'Enrolled',
        checkingStatement: 'Paper',
        visa: 'Paper',
        loan: 'Paper',
        mortgage: 'Paper',
        notification: 'Email',
        phone: '1123458923',
      },
      {
        id: '3',
        cif: 'TTTOOO',
        name: 'demonewusr',
        email: 'lee.st1@testinfoimageinc.com',
        status: 'active',
        ssoEnrollDate: enrollDate,
        dsoEnrollDate: '',
        notices: 'Paper',
        lastLogin: '',
        eTax: 'Paper',
        failedLoginCounter: '0',
        enrollmentStatus: 'Enrolled',
        checkingStatement: 'Paper',
        visa: 'Paper',
        loan: 'Paper',
        mortgage: 'Paper',
        notification: 'Email',
        phone: '1123458923',
      },
      {
        id: '4',
        cif: 'TTTOOO|ttt000',
        name: 'Justin Denver',
        email: 'justin@infoimage.com',
        status: 'active',
        notices: 'Paper',
        ssoEnrollDate: enrollDate,
        dsoEnrollDate: '',
        eTax: 'Paper',
        lastLogin: '',
        failedLoginCounter: '0',
        loan: 'Paper',
        enrollmentStatus: 'Enrolled',
        checkingStatement: 'Paper',
        visa: 'Paper',
        mortgage: 'Paper',
        notification: 'Email',
        phone: '1123458923',
      },
      {
        id: '5',
        cif: 'NEW01',
        name: 'Nate St. T',
        email: 'nate44@testinfoimageinc.com',
        status: 'active',
        notices: 'Paper',
        ssoEnrollDate: enrollDate,
        dsoEnrollDate: '',
        lastLogin: '',
        loan: 'Paper',
        failedLoginCounter: '0',
        eTax: 'Paper',
        enrollmentStatus: 'Enrolled',
        checkingStatement: 'Both',
        visa: 'Both',
        mortgage: 'Both',
        notification: 'Email & SMS',
        phone: '1123458923',
      },
    ],
  },
  {
    id: 'sv8080503',
    accountNumber: '8080503',
    accountType: 'SV',
    accountName: 'John Lee',
    status: 'inactive',
    subRows: [
      {
        id: '6',
        cif: 'ABC12|CDE34',
        name: 'Amy Denver',
        eTax: 'Paper',
        notices: 'Paper',
        loan: 'Paper',
        email: 'amy.de@infoimageinc.com',
        status: 'active',
        ssoEnrollDate: enrollDate,
        dsoEnrollDate: '',
        lastLogin: '',
        failedLoginCounter: '0',
        enrollmentStatus: 'Enrolled',
        checkingStatement: 'Both',
        visa: 'Both',
        mortgage: 'Both',
        notification: 'Email',
        phone: '1123458923',
      },
      {
        id: '7',
        cif: 'NEW01',
        name: 'Nate St. T',
        email: 'nate44@testinfoimageinc.com',
        status: 'active',
        eTax: 'Paper',
        loan: 'Paper',
        ssoEnrollDate: enrollDate,
        dsoEnrollDate: '',
        lastLogin: '',
        notices: 'Paper',
        failedLoginCounter: '0',
        enrollmentStatus: 'Enrolled',
        checkingStatement: 'Paper',
        visa: 'Paper',
        mortgage: 'Paper',
        notification: 'Email',
        phone: '1123458923',
      },
    ],
  },
  {
    id: 'td8080504',
    accountNumber: '8080504',
    accountType: 'TD',
    accountName: 'Amy Watt',
    status: 'inactive',
    subRows: [],
  },
];

export default accountManagementData;
